import { ArrowForward } from "@mui/icons-material";
import localize from "../../common/localize";
import { Chip } from "@mui/material";

export default function StatusChangeItem({ initialStatus, finalStatus }) {
  return (
    <div className="flex justify-between mr-2">
      <Chip
        style={{
          width: "100%",
          margin: "2px",
          fontSize: "12px",
          fontWeight: 400,
          backgroundColor: !finalStatus
            ? "#002121"
            : initialStatus?.BackgroundColor,
          color: !finalStatus ? "#FFFFFF" : initialStatus?.ForegroundColor,
        }}
        label={!finalStatus ? localize.no_status : initialStatus?.Name}
      />
      <div className="flex items-center m-1">
        <ArrowForward />
      </div>

      <Chip
        style={{
          width: "100%",
          margin: "2px",
          fontSize: "12px",
          fontWeight: 400,
          backgroundColor: !finalStatus
            ? initialStatus.BackgroundColor
            : finalStatus?.BackgroundColor,
          color: !finalStatus
            ? initialStatus.ForegroundColor
            : finalStatus?.ForegroundColor,
        }}
        label={!finalStatus ? initialStatus?.Name : finalStatus?.Name}
      />
    </div>
  );
}
